<template>
  <div>
    <c-table
      ref="table"
      title="화학자재 규제사항 이력 목록"
      gridHeight="700px"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :isExcelDown="false"
      :filtering="false"
      @linkClick="linkClick"
    />
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "chemLawHistory",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: "",
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "regUserDeptName",
            field: "regUserDeptName",
            label: "부서",
            align: "center",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "수정자",
            align: "center",
            sortable: true,
          },
          {
            name: "regDt",
            field: "regDt",
            label: "수정일시",
            align: "center",
            type: "link",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      popupOptions: {
        isFull: false,
        width: "100%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    gridHeight() {
      return this.contentHeight
        ? String(this.contentHeight - 200) + "px"
        : "500px";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.materialRegul.history.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
      };
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },

    linkClick(row) {
      this.popupOptions.title = "화학자재 규제사항 이력 조회";
      this.popupOptions.param = {
        mdmHistoryId: row ? row.mdmHistoryId : "",
        mdmChemMaterialId: row ? row.mdmChemMaterialId : "",
      };
      this.popupOptions.target = () =>
        import(`${"./chemLawHistoryDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = "80%";
      this.popupOptions.closeCallback = this.closePopup;
    },

    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
<style>
.lawspan {
  color: #0072c6 !important;
  font-size: 13px !important;
  font-weight: 600;
}
.divchklaw {
  margin-bottom: 10px;
}
</style>
